import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

export default function AddEditingProject(props) {
  const [projectName, setProjectName] = useState("");
  const [projectLocation, setProjectLocation] = useState("");
  const [enterprise, setEnterprise] = useState("");
  const [enterpriseList, setEnterpriseList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [locationsToAdd, setLocationsToAdd] = useState(new Set());
  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);
  const [showProjectLocationModal, setShowPojectLocationModal] = useState(false);

  function addProject(event) {
    event.preventDefault();
    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/add-new-project",
      data: {
        newProject: {
          projectName,
          projectLocation,
          enterprise,
          projectLocation: Array.from(locationsToAdd),
        },
      },
    })
      .then((res) =>
        res.status === 200
          ? (setProjectList((projectList) => [
              ...projectList,
              {
                project_name: projectName,
                project_location: projectLocation,
                entp_name: enterpriseList.filter(
                  (elem) => elem.entp_id === parseInt(enterprise)
                )[0].entp_name,
              },
            ]),
            alert("project Added!!!"))
          : null
      )
      .catch((err) => alert("server error!!!"));
  }

  function handleChange(event) {
    let id = event.target.id;
    let value = event.target.value;
    if (id === "project-name") setProjectName(value.toLowerCase());
    else if (id === "project-location") setProjectLocation(value.toLowerCase());
    else setEnterprise(value);
  }

  function addLocation(event) {
    if (event.target.value)
      setLocationsToAdd(
        (prev) =>
          new Set(
            prev.add(event.target.options[event.target.selectedIndex].text)
          )
      );
  }

  function removeLocation(location) {
    setLocationsToAdd(
      (prev) => new Set([...prev].filter((elem) => elem !== location))
    );
  }

  useEffect(() => {
    axios({
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/get-enterprise-data",
      method: "get",
    })
      .then((res) => (res.status === 200 ? setEnterpriseList(res.data) : null))
      .catch((err) => alert("server error!!!"));

    axios({
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/get-project-data",
      method: "get",
    })
      .then((res) => (res.status === 200 ? setProjectList(res.data) : null))
      .catch((err) => alert("server error!!!"));

    axios({
      method: "get",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/get-project-locations",
    })
      .then((res) => setLocationList(res.data))
      .catch((err) => alert("Server error!!!"));
  }, []);

  return (
    <div className="add-editing-project">
      <div className="project-data-input">
        <h4>Add Project</h4>
        <form onSubmit={addProject}>
          <div className="form-inputs">
            <input
              id="project-name"
              type="text"
              placeholder="project name"
              value={projectName}
              onChange={handleChange}
              required
            />
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="location-viewer">
                {Array.from(locationsToAdd).map((loc, idx) => (
                  <LocationTag
                    locationName={loc}
                    key={idx}
                    removeLocation={removeLocation}
                  />
                ))}
              </div>
              <div>
                <select
                  onChange={addLocation}
                  style={{ width: "93%" }}
                  required
                >
                  <option value="">Select Locations</option>
                  {locationList.map((e) => (
                    <option key={e.location_id} value={e.location_id}>
                      {e.location_name}
                    </option>
                  ))}
                </select>
                <b
                  title="click to add new project locations"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPojectLocationModal(true)}
                >
                  &#10133;
                </b>
              </div>
            </div>
            <div>
              <select
                value={enterprise}
                onChange={handleChange}
                id="select-enterprise"
                required
              >
                <option value="">Select Enterprise</option>
                {enterpriseList.map((entp, idx) => (
                  <option value={entp.entp_id} key={idx}>
                    {entp.entp_name}
                  </option>
                ))}
              </select>
              <b
                title="click to add new enterprise"
                style={{ cursor: "pointer" }}
                onClick={() => setShowEnterpriseModal(true)}
              >
                &#10133;
              </b>
            </div>
          </div>
          <div
            style={{ padding: "20px", marginTop: "20px" }}
            className="form-buttons"
          >
            <button type="submit">Add Project</button>
          </div>
        </form>
      </div>
      <div className="project-list">
        <table>
          <thead>
            <tr>
              <th>project name</th>
              <th>Enterprise Name</th>
            </tr>
          </thead>
          <tbody>
            {projectList.map((proj, idx) => (
              <tr key={idx}>
                <td>{proj.project_name}</td>
                <td>{proj.entp_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AddEnterprise
        setEnterpriseList={setEnterpriseList}
        show={showEnterpriseModal}
        onHide={() => setShowEnterpriseModal(false)}
      />
      <AddProjectLocation
        setLocationList={setLocationList}
        show={showProjectLocationModal}
        onHide={() => setShowPojectLocationModal(false)}
      />
    </div>
  );
}

function AddEnterprise(props) {
  function addEnterprise(event) {
    event.preventDefault();
    let form = event.currentTarget.elements;
    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/add-new-enterprise?enterprise_name=" +
        form.entp_name.value.toLowerCase(),
    })
      .then((res) => {
        props.onHide();
        if (res.data.error) {
          alert("enterprise already exists!!!\nTry with different a name");
        } else {
          props.setEnterpriseList((list) => [
            ...list,
            { entp_id: res.data, entp_name: form.entp_name.value },
          ]);
          alert("Enterprise added!!!");
        }
      })
      .catch((err) => alert("server error!!! please re-try"));
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ padding: "10px" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add New Enterprise
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={addEnterprise}>
          <div className="form-inputs">
            <input type="text" id="entp_name" placeholder="enterprise name" />
          </div>
          <div style={{ textAlign: "center" }} className="form-buttons">
            <button type="submit">Add Enterprise</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

function AddProjectLocation(props) {
  function addProjectLocation(event) {
    event.preventDefault();
    let form = event.currentTarget.elements;
    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/add-project-location?location=" +
        form.location_name.value,
    })
      .then((res) => {
        props.onHide();
        if (res.data.error) {
          alert("location already exists!!!\nTry with different a name");
        } else {
          props.setLocationList((list) => [
            ...list,
            { location_id: res.data, location_name: form.location_name.value },
          ]);
          alert("Location added!!!");
        }
      })
      .catch((err) => alert("server error!!! please re-try"));
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ padding: "10px" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add New Project Location
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={addProjectLocation}>
          <div className="form-inputs">
            <input type="text" id="location_name" placeholder="location name" />
          </div>
          <div style={{ textAlign: "center" }} className="form-buttons">
            <button type="submit">Add Location</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

function LocationTag(props) {
  return (
    <div
      onClick={() => props.removeLocation(props.locationName)}
      style={{
        cursor: "pointer",
        height: "max-content",
        margin: "3px 0px 5px 2px",
      }}
    >
      <span className="location-tag">{props.locationName} x</span>
    </div>
  );
}
